import React, { FunctionComponent } from "react";
import style from "../assets/styles/style.module.scss";
import "../assets/styles/flaticon.css";
import {Card, CardProps} from "../Card/Card";


type BenefitsProps = {services:CardProps[]};

export const Benefits: FunctionComponent<BenefitsProps> = ({services}) =>
    <div className={style.section}>
        <div className={style.container}>
            <div className={style.row}>
                {services.map(({icon, title, paragraph, className}) =>
                        <Card icon={icon}
                              title={title}
                              className={className}
                              paragraph={paragraph}/>)}
            </div>
        </div>
    </div>;
